export default __webpack_public_path__ + "static/enraged-9a42d5f5f89814f59651de176789b70c.svg";